import * as React from "react"
import {SvgFunction} from "@web-libs/ui/svgs/types";
import {withColor} from "@web-libs/ui/svgs/fill/with-color";
const _RegisterIcon: SvgFunction = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 62 20"
        width={62}
        height={20}
        fill="none"
    >
        <path
            fill={props.fill ?? "#1E2025"}
            d="M60.884 10.884a1.25 1.25 0 0 0 0-1.768l-7.955-7.955A1.25 1.25 0 1 0 51.16 2.93L58.232 10l-7.07 7.071a1.25 1.25 0 1 0 1.767 1.768l7.955-7.955ZM0 11.25h60v-2.5H0v2.5Z"
        />
    </svg>
)

const RegisterIcon = withColor(_RegisterIcon)
export default RegisterIcon
